export default __webpack_public_path__ + "static/media/IP_List.3351181e.svg";